import { useContext, createContext } from "react";
import Web3 from "web3";
import { useWalletClient } from "wagmi";
import CrowdFundingABI from "../ABI/CrowdfundingABI"
import TokenABI from "../ABI/TokenABI"
import { ContractAddresses } from "../constants/contractAddresses";

// Creating a new context
const StateMintingContext = createContext();

export const StateMintingContextProvider = ({ children }) => {
    const { data: walletClient } = useWalletClient();

    const web3Pro = walletClient
        ? walletClient :
        "https://sepolia.infura.io/v3/15c9a4fbcf3f477f978e0e2765809365";

    const web3 = new Web3(web3Pro);

    const CrowdfundingInstance = new web3.eth.Contract(CrowdFundingABI, ContractAddresses.CrowdFundingAddress);
    const TokenInstance = new web3.eth.Contract(TokenABI, ContractAddresses.TokenAddress);

    //All functions from CrowdFunding ABI

    // get total minted nfts count
    const fetchAllProjects = async () => {
        try {
            const response = await CrowdfundingInstance.methods.getAllProjects().call();
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    const checkIsVolunteer = async (walletAddress) => {
        try {
            const response = await CrowdfundingInstance.methods.isVolunteer(walletAddress).call();
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    const createProject = async (projectData, walletAddress) => {
        try {
            const response = await CrowdfundingInstance.methods.createProject(
                projectData._projectName,
                projectData._projectDescription,
                projectData._location,
                projectData._targetTime,
                projectData._requiredFunds,
                projectData.facebook,
                projectData.twitter,
                projectData.instagram,
                projectData.socialLink,
                projectData._tags
            ).send({
                from: walletAddress,
            });

            return response;
        } catch (error) {
            console.log("createProject Error:", error);
            throw error;
        }
    };


    //All functions from Token ABI

    //get Balance function
    const getBalance = async (wallet_address) => {
        try {
            const balance = await TokenInstance.methods
                .balanceOf(wallet_address)
                .call();
            return balance;
        } catch (error) {
            throw error;
        }
    };

    //approval function
    const giveApproval = async (wallet_address, contractAddress, totalSupply) => {
        try {
            const approveResult = await TokenInstance.methods
                .approve(
                    contractAddress,
                    totalSupply
                )
                .send({ from: wallet_address });
            return approveResult;
        } catch (error) {
            throw error;
        }
    };

    //donate function
    const giveDonation = async (wallet_address, projectId, donationAmount) => {
        try {
            const response = await CrowdfundingInstance.methods
                .donate(
                    projectId,
                    donationAmount
                )
                .send({ from: wallet_address });
            return response;
        } catch (error) {
            throw error;
        }
    };

    //check allowance function
    const checkAllowance = async (wallet_address, contractAddress) => {
        try {
            const allowanceResult = await TokenInstance.methods
                .allowance(
                    wallet_address,
                    contractAddress
                )
                .call({ from: wallet_address });
            return allowanceResult;
        } catch (error) {
            throw error;
        }
    };

    return (
        <StateMintingContext.Provider
            value={{
                fetchAllProjects,
                checkIsVolunteer,
                createProject,
                getBalance,
                giveApproval,
                checkAllowance,
                giveDonation
            }}>
            {children}
        </StateMintingContext.Provider>
    );
};

export const useMintingStateContext = () => useContext(StateMintingContext);
